/*

? Data Imports

*/

import { customList } from "country-codes-list";
import { hasFlag } from "country-flag-icons";

/*

& Interface and type definitions

*/

export interface CountryCodeOptionInterface {
	code: string;
	name: string;
	call: string;
}

export type CountryCodeOption = CountryCodeOptionInterface | null;

/*

& Create custom list of countries

*/

// @ts-ignore
const countries: Record<string, string> = customList("countryCallingCode", "{countryCode}|{countryNameEn}");

/*

& Create list of country code options

*/

const countryCodeOptionsUnTested: Array<CountryCodeOptionInterface> = Object.keys(countries).map((call: string) => {
	const [code, name] = countries[call].split("|");
	return {
		code,
		name,
		call,
	};
});

/*

& Filter out countries that do not have a flag or are not in the list

*/

const SUPPORTED_COUNTRIES: Array<string> = ["IN", "AE", "SG", "UM"];

const countryCodeOptionsUnSorted: Array<CountryCodeOptionInterface> = countryCodeOptionsUnTested.filter(
	(country: CountryCodeOptionInterface) => hasFlag(country.code) && SUPPORTED_COUNTRIES.includes(country.code),
);

/*

& Sort countries by name

*/

export const countryCodeOptions: Array<CountryCodeOptionInterface> = countryCodeOptionsUnSorted.sort((a, b) =>
	a.name.localeCompare(b.name),
);
/*

& Create Maps for easy access

*/

const countryCodeOptionsMapCode: Map<string, CountryCodeOptionInterface> = new Map(
	countryCodeOptions.map((country: CountryCodeOptionInterface) => [country.code, country]),
);

const countryCodeOptionsMapName: Map<string, CountryCodeOptionInterface> = new Map(
	countryCodeOptions.map((country: CountryCodeOptionInterface) => [country.name, country]),
);
const countryCodeOptionsMapCall: Map<string, CountryCodeOptionInterface> = new Map(
	countryCodeOptions.map((country: CountryCodeOptionInterface) => [country.call, country]),
);

/*

& Create a getter function for all countries

*/

const getCountry: (searchParameter: string) => CountryCodeOption = (searchParameter: string) => {
	if (countryCodeOptionsMapCode.has(searchParameter)) {
		return countryCodeOptionsMapCode.get(searchParameter) || null;
	}
	if (countryCodeOptionsMapName.has(searchParameter)) {
		return countryCodeOptionsMapName.get(searchParameter) || null;
	}
	if (countryCodeOptionsMapCall.has(searchParameter)) {
		return countryCodeOptionsMapCall.get(searchParameter) || null;
	}
	return null;
};

/*

& Default export

*/

export default getCountry;
